/**
 * @file index.js
 * @author rongtan<rongtan@baidu.com>
 * @date 2021-04-06
 */

import {Component} from 'san';
import './index.scss';

export default class InvokeAppBrand extends Component {
    static template = `
        <div class="invoke-app-brand">
            <div class="left-wrap">
                <img class="logo" src="https://gemapp.cdn.bcebos.com/pic/a0uuf02f813d71286868b5f8"/>
                <div class="text-wrap">
                    <div class="title">古物潮玩</div>
                    <div class="sub-title">有趣的艺术品交流社区</div>
                </div>
            </div>
            <div class="right-wrap">
                <div class="btn">APP内阅读</div>
            </div>
        </div>
    `;
}
